import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import LocationService from "../../src/Services/Location.service";
const LocationLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return LocationService.findLocationsById(ids);
        },
        fetchOptions: (search) => {
            return LocationService.getLocations(search);
        },
        optionRenderer: function locationRenderer(location) {
            return _jsx("span", { children: location.name });
        },
    });
};
export default LocationLookup;
